module.exports = __webpack_public_path__ + "static/media/ftm_logo_blue.d8eaf3b2.svg";